import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Experiments } from '../../constants/experiments';
import DonateButton from '../DonateButton/DonateButton';
import Modal from '../Modal/Modal';
import { TickIcon } from './TickIcon';

import styles from './DonateToYourselfModal.scss';

interface DonateToYourselfModalProps {
  onClose: () => void;
  heading: string;
  description: string;
  donateButtonLabel: string;
}

// B2C_044 - donate to yourself
// Remove this experiment when complete
export const DonateToYourselfModal: FunctionComponent<DonateToYourselfModalProps> = ({
  onClose,
  heading,
  description,
  donateButtonLabel,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Modal onCloseRequest={onClose} className={styles.modal} displayCloseButton>
      <TickIcon className={styles.icon} />
      <p>{t('fundraising.donateToYourself.modal.superHeading')}</p>
      <h1 className="jg-h1">{heading}</h1>
      <p>{description}</p>
      <DonateButton
        className={styles.donateButton}
        trackingDataPageSection="DonateToYourself"
        experiments={[
          // B2C_044 - donate to yourself
          // Remove this experiment when complete
          Experiments.b2c_044_donate_to_yourself,
        ]}
        successType="ModalSelfDonateButtonClick"
        label={donateButtonLabel}
      />
      <button className={styles.dismissLink} onClick={onClose}>
        {t('fundraising.donateToYourself.modal.dismiss')}
      </button>
    </Modal>
  );
};
